<template>
  <div class="icon-selector">
    <!-- <pre>{{iconlist}}</pre> -->
    <div class="icon-list" v-if="edit_mode">
      <font-awesome-icon
        v-for="icon in iconlist"
        :key="icon"
        :icon="icon"
        class="selectable-icon"
        @click="onSelectIcon(icon)"/>
      <a href="#" @click.prevent="onSelectIcon(null)">No icon</a>
    </div>
    <div v-else>
      <font-awesome-icon
        v-if="current_icon"
        :icon="current_icon"
        class="preview-icon"
        @click="edit_mode = true"
        size="4x" />
      <div v-else
        class="no-icon-selected"
        @click="edit_mode = true">
        No icon selected
      </div>
    </div>
  </div>
</template>

<script>
import library from '@/misc/icons'

export default {
  props: {
    value: {}
  },
  data: () => ({
    edit_mode: false,
    iconlist: [],
    current_icon: null,
  }),
  watch: {
    value: {
      handler( newValue ) {
        this.current_icon = newValue;
      },
      immediate: true
    }
  },
  created() {
    this.iconlist = Object.keys( library.definitions.fas );
    // console.log("library", library.definitions);
  },
  computed: {
  },
  methods: {
    onSelectIcon(icon) {
      this.edit_mode = false;
      this.current_icon = icon;
      this.$emit('input', icon)
    }
  }
}
</script>

<style>
.icon-selector {
  color: black;
}
.icon-selector .icon-list {
  border: 1px solid black;
  background-color: white;
  padding: 10px;
}
.icon-selector .selectable-icon {
  cursor: pointer;
  margin: 1px;
  width: 25px;
  height: 25px;
  color: #666;
  background-color: #EEE;
  padding: 5px;
}
.icon-selector .selectable-icon:hover {
  background-color: #DDD;
}
.icon-selector .no-icon-selected {
  cursor: pointer;
  border: 1px solid #AAA;
  color: black;
  width: 60px;
  height: 60px;
  background-color: white;
  text-align: center;
  font-size: 80%;
  padding-top: 10px;
}
.icon-selector .preview-icon {
  cursor: pointer;
}
.icon-selector .preview-icon:hover {
  color: #333;
}
</style>
